import axios from "axios";
import { useState } from "react";
import { API } from "../configs/urlConfig";
import { useNavigate } from "react-router-dom";
axios.defaults.withCredentials = true;
function Login() {
  const navigate = useNavigate(); // <-- dodaj navigate
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    // demo validacija
    if (!username || !password) {
      setError("Unesi korisničko ime i lozinku");
      return;
    }
    setError("");

    const items = {
      username: username,
      password: password,
    };

    const { data } = await axios.post(`${API}/signin/`, { items });
    if (!data.error) {
      await localStorage.setItem("jwt", data.user.token);

      navigate("/", { replace: true }); // <-- IDE NA HOME
    } else {
      setError('Neispravno korisničko ime ili lozinka');
    }
    // ovdje ide API login kasnije
  };

  return (
    <section className="login-shell d-flex align-items-center justify-content-center min-vh-100">


      {/* LOGIN CARD */}
      <div className="login-card card p-4 shadow" style={{ width: "100%", maxWidth: "400px" }}>
        <h2 className="mb-2">Dobrodošli nazad</h2>

        <p className="text-muted mb-4">
          Unesi korisničko ime i lozinku da pristupiš sistemu.
        </p>

        {error && (
          <div className="alert alert-danger">{error}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Korisničko ime</label>
            <input
              className="form-control"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <div className="mb-4">
            <label className="form-label">Lozinka</label>
            <input
              className="form-control"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button className="btn btn-primary btn-lg w-100" type="submit">
            Prijavi se
          </button>
        </form>
      </div>
    </section>
  );
}

export default Login;

// import { useState } from "react";
// import { useNavigate } from "react-router-dom";

// function Login({ setIsAuth }) {
//   const [username, setUsername] = useState("");
//   const navigate = useNavigate();

//   const handleLogin = (e) => {
//     e.preventDefault();

//     if (username.trim() !== "") {
//       setIsAuth(true);
//       navigate("/");
//     }
//   };

//   return (
//     <div>
//       <h1>Login</h1>

//       <form onSubmit={handleLogin}>
//         <input
//           type="text"
//           placeholder="Username"
//           value={username}
//           onChange={(e) => setUsername(e.target.value)}
//         />
//         <button type="submit">Login</button>
//       </form>
//     </div>
//   );
// }

// export default Login;